import { Fragment } from 'react';
import { Typography } from '@mui/material';

/**
 * Renders a feature name string, turning text wrapped in `#...#` into bold spans.
 * Example: "#Bold# Normal" → <strong>Bold</strong> Normal
 */
export const renderFeatureName = (name: string): React.ReactNode => {
    const parts = name.split(/#([^#]+)#/);

    if (parts.length === 1) {
        return name;
    }

    return (
        <Fragment>
            {parts.map((part, index) =>
                index % 2 === 1 ? (
                    <Typography key={index} component="span" fontWeight="bold">
                        {part}
                    </Typography>
                ) : (
                    part
                ),
            )}
        </Fragment>
    );
};
